import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-user" }
const _hoisted_2 = { class: "flex flex-row gap-4" }
const _hoisted_3 = { class: "flex flex-row gap-4" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row gap-4"
}

import { ref, computed, watchEffect, watch } from "vue";
import { useI18n } from "vue-i18n";

import type { UserType, UserRegisterType } from "@/common/types/user";

import {
  baseCheckbox,
  baseInput,
  baseMultiselect,
  basePassword,
  baseSelect,
  baseTextarea,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-user',
  props: {
    data: {},
    isEdit: { type: Boolean }
  },
  emits: ["update-data"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
  login: "",
  name: "",
  email: "",
  type: "",
  status: "",
};

const payload = ref<UserRegisterType>({ ...DEFAULT_DATA });
const errors = ref<{ [key: string]: string }>({});

const isValid = ref(false);

const password = ref("");
const passwordConfirm = ref("");

const optionStatus = [
  { option: t("common.labels.active"), value: "ACTIVE" },
  { option: t("common.labels.inactive"), value: "INACTIVE" },
];

const optionType = [
  { option: t("common.labels.administrator"), value: "ADMIN" },
  { option: t("common.labels.manager"), value: "MANAGER" },
];

function validate() {
  Object.keys(payload.value).forEach((key) => {
    delete errors.value[key];

    if (!payload.value[key] && key !== "active")
      errors.value[key] = t("error.required");
  });

  isValid.value = Object.keys(errors.value).length === 0;
}

function validatePassword() {
  delete errors.value["password"];

  if (!password.value || !passwordConfirm.value)
    errors.value["password"] = t("error.required");

  if (password.value !== passwordConfirm.value)
    errors.value["password"] = t("error.not_equal");

  isValid.value = Object.keys(errors.value).length === 0;
}

function update() {
  validate();

  emit("update-data", payload.value);
}

function updatePassword() {
  validatePassword();

  payload.value = {
    ...payload.value,
    password: password.value,
  };

  emit("update-data", payload.value);
}

function resumeData() {
  if (!props.data) return;

  const { login, name, email, type, status } = props.data;

  payload.value = {
    ...payload.value,
    login,
    name,
    email,
    type,
    status,
  };

  if (props.data.password) {
    password.value = props.data.password;
    passwordConfirm.value = props.data.password;
  }
}

function valid() {
  validate();
  validatePassword();
}

__expose({ valid, isValid });

watch(
  () => props.data,
  () => {
    resumeData();
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
      value: payload.value.name,
      placeholder: _unref(t)('common.placeholders.name'),
      required: "",
      maxlength: "75",
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (update()))
    }, _createSlots({
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
      ]),
      _: 2
    }, [
      (errors.value.name)
        ? {
            name: "error",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(errors.value.name), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "value", "placeholder"]),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.login,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.login) = $event)),
        value: payload.value.login,
        placeholder: _unref(t)('common.placeholders.login'),
        required: "",
        maxlength: "20",
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (update()))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.login")) + " *", 1)
        ]),
        _: 2
      }, [
        (errors.value.login)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.login), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.email,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.email) = $event)),
        value: payload.value.email,
        placeholder: _unref(t)('common.placeholders.email'),
        required: "",
        maxlength: "75",
        onBlur: _cache[5] || (_cache[5] = ($event: any) => (update()))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.email")), 1)
        ]),
        _: 2
      }, [
        (errors.value.email)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.email), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value", "placeholder"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.type,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.type) = $event)),
        value: payload.value.type,
        options: optionType,
        "is-empty": false,
        onChange: _cache[7] || (_cache[7] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.status,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.status) = $event)),
        value: payload.value.status,
        options: optionStatus,
        "is-empty": false,
        onChange: _cache[9] || (_cache[9] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"])
    ]),
    (!__props.isEdit)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createVNode(_unref(basePassword), {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((password).value = $event)),
            value: password.value,
            placeholder: _unref(t)('user.placeholders.password'),
            minlength: "8",
            maxlength: "25",
            onChange: _cache[11] || (_cache[11] = ($event: any) => (updatePassword()))
          }, _createSlots({
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("user.labels.password")) + " *", 1)
            ]),
            _: 2
          }, [
            (errors.value.password)
              ? {
                  name: "error",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(errors.value.password), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "value", "placeholder"]),
          _createVNode(_unref(basePassword), {
            modelValue: passwordConfirm.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((passwordConfirm).value = $event)),
            value: passwordConfirm.value,
            placeholder: _unref(t)('user.placeholders.confirm_password'),
            minlength: "8",
            maxlength: "25",
            onChange: _cache[13] || (_cache[13] = ($event: any) => (updatePassword()))
          }, _createSlots({
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("user.labels.confirm_password")) + " *", 1)
            ]),
            _: 2
          }, [
            (errors.value.password)
              ? {
                  name: "error",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(errors.value.password), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "value", "placeholder"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})